import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import CreateDailyCheckInListing from '@/modules/promotion/components/CreateDailyCheckIn/components/CreateDailyCheckInListing'

function CreateDailyCheckInPage() {
	return (
		<PageContainer>
			<CreateDailyCheckInListing />
		</PageContainer>
	)
}

const GuardedCreateDailyCheckInPage = withUserPermission(
	CreateDailyCheckInPage,
	{
		permissionType: PermissionType.Write,
		permissionKey: [PermissionKeys.MANAGE_DAILY_CHECK_IN],
	},
)

export default GuardedCreateDailyCheckInPage
